import eventNames from '../eventNames';
import track from '../track';

export function trackCheckboxErrorMessage(params: {
  site: string;
  moduleName: string;
}) {
  track(eventNames.checkbox_error_message, {
    component: 'checkbox',
    ...params,
  });
}
